export const TWO_SIZE_VARIANT = ["small", "large"];
export const THREE_SIZE_VARIANT = ["small", "regular", "large"];
